import {RigaGaranzia} from '../models/rigagaranzia';
export class Garanzia {
    codice:string;
    codiceMacchina:string;
    dataRottura:any;
    dataVendita:any;
    email:string;
    foto:string;
    indirizzo:string;
    modello:string;
    notaAccredito:boolean;
    serialNo:string;
    testo:string;
    righe: Array<RigaGaranzia>;

}



// WEBPACK FOOTER //
// ./src/app/models/garanzia.ts